import { apiClient } from "./client";

export async function getBlogs(lang) {
    const res = await apiClient.get("/api/blogs", {
        params: lang ? { lang } : undefined,
    });
    return res.data;
}

export async function getBlogById(id, lang) {
    const res = await apiClient.get(`/api/blogs/${id}`, {
        params: lang ? { lang } : undefined,
    });
    return res.data;
}

export async function getBlogBySlug(slug, lang) {
    const res = await apiClient.get(`/api/blogs/slug/${encodeURIComponent(slug)}`, {
        params: lang ? { lang } : undefined,
    });
    return res.data;
}

export async function createBlog(payload) {
    const res = await apiClient.post("/api/blogs", payload);
    return res.data;
}

export async function updateBlog(id, payload) {
    const res = await apiClient.put(`/api/blogs/${id}`, payload);
    return res.data;
}

export async function deleteBlog(id) {
    const res = await apiClient.delete(`/api/blogs/${id}`);
    return res.data;
}

/**
 * @param {File} file
 * @returns {Promise<{ pdfUrl: string }>}
 */
export async function uploadBlogPdf(file) {
    const formData = new FormData();
    formData.append("pdf", file);
    const res = await apiClient.post("/api/blogs/upload-pdf", formData);
    return res.data;
}

/**
 * @param {File} file
 * @returns {Promise<{ imageUrl: string }>}
 */
export async function uploadBlogImage(file) {
    const formData = new FormData();
    formData.append("image", file);
    const res = await apiClient.post("/api/blogs/upload-image", formData);
    return res.data;
}

/**
 * @returns {Promise<{ images: Array<{ imageUrl: string, filename: string, updatedAt: string }> }>}
 */
export async function listBlogImages() {
    const res = await apiClient.get("/api/blogs/upload-images");
    return res.data;
}
